import { useOutletContext } from 'react-router-dom';
import { Centered } from '../../layouts/Base';
import styles from './SetupSubPage.module.css';

/**
 * Wrapper for agent setup sub-pages. When rendered inside the setup portal
 * (inSetupPortal from outlet context), uses setup sub-page styling (no gray band).
 * Otherwise wraps in Centered for standalone use.
 */
function SetupPortalPage({ children }) {
    const inSetupPortal = useOutletContext()?.inSetupPortal === true;

    if (inSetupPortal) {
        return <div className={styles.setupSubPage}>{children}</div>;
    }
    return <Centered>{children}</Centered>;
}

export default SetupPortalPage;
